
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./dom-mutator.cjs.production.min.js')
} else {
  module.exports = require('./dom-mutator.cjs.development.js')
}
